import { useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { SyncLogStatusAlert } from '@sparklayer-io/spark-dash-pages/features/sync';

export function CustomersSyncLogAlert() {
  const env = useEnv();

  if (!env?.platform) {
    return null;
  }

  return (
    <SyncLogStatusAlert
      syncFor={{ integration: env.platform, dataType: 'customers' }}
      allowViewErrors={true}
    />
  );
}
